module.exports = __webpack_public_path__ + "static/media/javitott_meglevo_szamlak6.be40666c.jpg";